import styled from 'styled-components';

interface IContainer {
  primary: string;
  secondary: string;
}

export const Container = styled.div<IContainer>`
  --shimmer-primary: ${({ primary }) => primary};
  --shimmer-secondary: ${({ secondary }) => secondary};

  background-image: linear-gradient(
    -90deg,
    var(--shimmer-secondary) 0%,
    var(--shimmer-primary) 50%,
    var(--shimmer-secondary) 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;
